import {createAsyncThunk, createSlice, isAnyOf} from '@reduxjs/toolkit';
import {IEducationState} from "../../../../interface/Passport/Education/frontend";
import {IErrorResult, IServerError} from "../../../../interface/Basic/api";
import {
    Education,
    IEducationsResponse,
    InputOption,
    IOption,
    IOptionsResponse,
    ISaveEductionRequest
} from "../../../../interface/Passport/Education/backend";
import {
    deleteEducation,
    getCities,
    getCountries,
    getEducationInstitutions,
    getEducationInstitutionTypes,
    getEducations,
    saveEducation
} from "./api";

export const GetEducationInstitutionTypes = createAsyncThunk<IOptionsResponse, undefined, { rejectValue: IErrorResult }>
('getEducationTypes', (data, thunkAPI) => getEducationInstitutionTypes()
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))

export const GetCountries = createAsyncThunk<IOptionsResponse, undefined, { rejectValue: IErrorResult }>
('getCounty', (data, thunkAPI) => getCountries()
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))

export const GetCities = createAsyncThunk<IOptionsResponse, number, { rejectValue: IErrorResult }>
('getCity', (data, thunkAPI) => getCities(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))

export const GetEducationInstitutes = createAsyncThunk<IOptionsResponse, number, { rejectValue: IErrorResult }>
('getEducationInstitutes', (data, thunkAPI) => getEducationInstitutions(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))

export const GetEducations = createAsyncThunk<IEducationsResponse, undefined, { rejectValue: IErrorResult }>
('getEducations', (data, thunkAPI) => getEducations()
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))

export const SaveEducation = createAsyncThunk<undefined, ISaveEductionRequest, { rejectValue: IErrorResult }>
('saveEducation', (data, thunkAPI) => saveEducation(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))

export const DeleteEducation = createAsyncThunk<undefined, number, { rejectValue: IErrorResult }>
('deleteEducation', (data, thunkAPI) => deleteEducation(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))

export const slice = createSlice({
    name: 'education',
    initialState: {
        educations: [
            {
                "id": 1,
                "education_institution": {
                    "id": 3,
                    "name": "МГУ",
                    "education_institution_type": {
                        "id": 3,
                        "name": "Высшее"
                    },
                    "city": {
                        "id": 1,
                        "name": "Москва",
                        "country": {
                            "id": 1,
                            "name": "Россия"
                        }
                    }
                },
                "faculty": {
                    "id": 9,
                    "name": "Вычистительной Матеметики и Кибернетики"
                },
                "education_level": {
                    "id": 9,
                    "name": "бакалавриат"
                },
                "start_year": "2004",
                "end_year": "2022"
            }, {
                "id": 2,
                "education_institution": {
                    "id": 3,
                    "name": "МГУ",
                    "education_institution_type": {
                        "id": 3,
                        "name": "Высшее"
                    },
                    "city": {
                        "id": 1,
                        "name": "Москва",
                        "country": {
                            "id": 1,
                            "name": "Россия"
                        }
                    }
                },
                "faculty": null,
                "education_level": null,
                "start_year": "2004",
                "end_year": null
            },
        ],
        education_institution_types: [
            {
                id: 1,
                name: 'Среднее образование'
            }, {
                id: 2,
                name: 'Высшее образование'
            }, {
                id: 3,
                name: 'Дополнительное образование'
            },
        ],
        countries: [],
        cities: [],
        education_institutions: [],
        faculties: [],
        is_success: false,
        error: {},
    } as IEducationState,
    reducers:
        {},
    extraReducers: (builder) => {
        builder.addCase(GetEducationInstitutionTypes.fulfilled, (state, action) => {
            const data = action.payload.data
            state.education_institution_types = data.map((item: IOption) => InputOption.parse(item));
        })

        builder.addCase(GetCountries.fulfilled, (state, action) => {
            const data = action.payload.data
            state.countries = data.map((item: IOption) => InputOption.parse(item));
        })

        builder.addCase(GetCities.fulfilled, (state, action) => {
            const data = action.payload.data
            state.cities = data.map((item: IOption) => InputOption.parse(item));
        })

        builder.addCase(GetEducationInstitutes.fulfilled, (state, action) => {
            const data = action.payload.data
            state.education_institutions = data.map((item: IOption) => InputOption.parse(item));
        })

        builder.addCase(GetEducations.fulfilled, (state, action) => {
            const data = action.payload.data;
            state.educations = data.map((education) => Education.parse(education))
        })

        builder.addMatcher(isAnyOf(
                SaveEducation.fulfilled,
                DeleteEducation.fulfilled),
            (state) => {
                state.is_success = true
            })

        builder.addMatcher(isAnyOf(
                SaveEducation.pending,
                SaveEducation.rejected,
                DeleteEducation.pending,
                DeleteEducation.rejected),
            (state) => {
                state.is_success = false
            })
    }
})

export const {} = slice.actions;

export default slice.reducer;